import React from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { toProperCase } from '../../utils/Common';
import { getUser } from '../../utils/Common';
import { CopyToClipboard } from 'react-copy-to-clipboard';

export default function AccessControlHeader({
  user,
  builder,
  history,
  copied,
  onCopy,
  isMobile,
}) {
  const displayName = user
    ? (user.firstName
      ? `${toProperCase(user.firstName)}${user.lastName ? ` ${toProperCase(user.lastName)}` : ''}`
      : user.email.split('@')[0])
    : 'User';

  return (
    <header className="access-control-header user-access-detail-header">
      <nav className="brand-breadcrumb">
        <Link to="/dashboard">Dashboard</Link>
        <span className="brand-breadcrumb-sep">/</span>
        <Link to={`/accesscontrol/${builder.builderId}`}>Access Control</Link>
        <span className="brand-breadcrumb-sep">/</span>
        <span className="brand-breadcrumb-current">{displayName}</span>
      </nav>
      <div className="user-access-detail-title-row">
        <h1 className="access-control-section-title user-access-detail-title">
          {displayName}&rsquo;s Settings
        </h1>
        <div className="header-buttons">
          <Button
            className="btn-brand-outline btn-compact"
            onClick={() => history.push(`/accesscontrol/${builder.builderId}`)}
          >
            <i className="fas fa-arrow-left" /> {isMobile ? 'All Users' : 'Return to All Users'}
          </Button>
          {getUser().role === 'ADMIN' && (
            <CopyToClipboard text={user.userId} onCopy={onCopy}>
              <Button className="btn-brand-outline btn-compact">
                {copied ? 'Copied!' : (isMobile ? 'Copy ID' : 'Copy User ID')}
              </Button>
            </CopyToClipboard>
          )}
        </div>
      </div>
    </header>
  );
}
